import { render, staticRenderFns } from "./UserNotificationForm.vue?vue&type=template&id=545ca38c&scoped=true&"
import script from "./UserNotificationForm.vue?vue&type=script&lang=js&"
export * from "./UserNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationForm.vue?vue&type=style&index=0&id=545ca38c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ca38c",
  null
  
)

export default component.exports